document.addEventListener("DOMContentLoaded", function() {
    const productGrid = document.getElementById('product-grid');
    const oneColumnButton = document.getElementById('one-column-button');
    const twoColumnButton = document.getElementById('two-column-button');

    // Event listener for One Column button
    oneColumnButton.addEventListener('click', function(event) {
        event.preventDefault(); // Prevent the default action (page refresh)
        productGrid.classList.remove('two-column'); // Remove two-column class
        productGrid.classList.add('one-column'); // Add one-column class
        console.log('1');
    });

    // Event listener for Two Column button
    twoColumnButton.addEventListener('click', function(event) {
        event.preventDefault(); // Prevent the default action (page refresh)
        productGrid.classList.remove('one-column'); // Remove one-column class
        productGrid.classList.add('two-column'); // Add two-column class
        console.log('2');
    });
});
